// 雇用（社員）で委託料の集計対象外（本城さん 2026-06-08 受領）。
// CSVに出てきても通知書を作らず、未登録エラーにもしない（突合からスキップ）。
// ※ 将来は統合マスターの「雇用区分」で管理する（#10）。それまでの暫定リスト。

import { normalizeName } from "../lib/normalize";

// 受領した雇用者の氏名（所属はメモ）
//   空田博(ヤマト周南) / 松冨志啓(ヤマト防府江泊) / 宮野律子(ヤマト下小鯖)
//   森元辰弥(ヤマト山口維新公園前) / 有田涼(ヤマト維新 or 佐川 複数勤務) /
//   佐藤義継(佐川山口) / 山崎秀二(佐川山口)
export const EXCLUDED_EMPLOYEE_NAMES = [
  "空田 博",
  "松冨 志啓",
  "宮野 律子",
  "森元 辰弥",
  "有田 涼",
  "佐藤 義継",
  "山崎 秀二",
];

// 正規化した氏名のセット（突合時の判定用）
export const EXCLUDED_EMPLOYEE_NORMS = new Set(EXCLUDED_EMPLOYEE_NAMES.map(normalizeName));

// CSVドライバー名が雇用者（集計対象外）かどうか
export function isExcludedEmployee(nameNormalized: string): boolean {
  return EXCLUDED_EMPLOYEE_NORMS.has(nameNormalized);
}
